import Cookies from 'js-cookie';
import { QUERY_PARAMS } from './constants';

function buildURLWithParams(path, params, flow) {
  return params ? `${flow}&redirect=${path}&${QUERY_PARAMS.CABINET}=${params}` : flow;
}

// Hide bubble if interrupter is enabled and user has not yet declined
function hideBubbleForInterrupter() {
  const enableDiscountEmailEntry = typeof window !== 'undefined'
    ? window?.__EXPERIENCE_PROPS__?.expConfiguration?.['fs:enableDiscountEmailEntry']
    : false;

  return enableDiscountEmailEntry && !Cookies.get('emailPromoDeclined');

}

export { buildURLWithParams, hideBubbleForInterrupter };